import $ from 'jquery'
// import Swiper JS
import slick from 'slick-carousel'
import Screen from "./screen";


export default class BasicSlider {
  constructor() {
    this.screen = new Screen();
  }

  init() {
    let $slickElement = $('.js-basic-slider')

    this.iniSlider($slickElement);

    window.addEventListener("resize", () => {
      this.iniSlider($slickElement);
    })
  }

  iniSlider($slickElement) {
    let $elem = $slickElement; 

    if (!this.screen.isPC) {
      if( $elem.length > 0 ) {
        $elem.not('.slick-initialized').slick({
          dots: true,
          infinite: true,
          slidesToShow: 1,
          variableWidth: true,
          slidesToScroll: 1,
          arrows: false
        });
      }
    } else {
      if($elem.hasClass('slick-initialized')) {
        $elem.slick('unslick')
        $elem.removeClass('is-slick')
        $('.js-matchHeight-target-two').removeAttr('style');
      }
    }
  }
}
